import { useQuery } from 'react-query';

import { api } from '../api';
import { TipoProd } from '../../types/TipoProd';

export interface ITransactions {
  dtHrTransacao: string;
  tipoProd: TipoProd;
  bandeira: string;
  descricao: string;
  vlTransacao: number;
  situacao: 'A' | 'C';
  codAutTransacao: string;
  nsuTransacao: string;
  cartaoBIN: string;
  cartaoHolder: string;
  qtdParcela: number;
  estabDocto: string;
  estabFantasia: string;
  terminal: string;
}

interface IParams {
  docto: string;
  dtInicial: string;
  dtFinal: string;
  pagina?: number;
  limite?: number;
  bandeira: string;
  tipoProd: string;
}

interface GetRelatorioPagamentoResult {
  transactions: ITransactions[];
  total: number;
}

export async function getVendas(
  params: IParams
): Promise<GetRelatorioPagamentoResult> {
  const { data } = await api.get('transactions', {
    params,
  });

  return { transactions: data, total: data.length };
}

export function useVendas(params: IParams) {
  return useQuery(
    [
      'vendas',
      params.docto,
      params.dtInicial,
      params.dtFinal,
      params.pagina,
      params.limite,
      params.bandeira,
      params.tipoProd,
    ],
    () => getVendas(params),
    {
      staleTime: Infinity,
      enabled:
        String(api.defaults.headers.common.authorization).length > 10 &&
        !!params.docto,
      retry: 2
    }
  );
}
